import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import {
  AuthAnyGuard,
  AuthGuestDeactivateGuard,
  AuthShadowGuard,
  DEFAULT_PARTNER_ROUTE_PATH,
  DESIGN_GUEST_ROUTE_PATH,
  EVENT_SUMMARY_GUEST_ROUTE_PATH,
  InternalRedirectGuard,
  MaintenanceCheckGuard,
  OM_QUOTE_PATH,
  SHADOW_LOGIN_PATH,
  SHOWROOM_GUEST_ROUTE_PATH,
  USER_TYPE_ADMIN,
  USER_TYPE_CLIENT,
  USER_TYPE_PARTNER,
  UserRoles,
} from "../core";
import { PageNotFoundComponent } from "../public/page-not-found/page-not-found.component";
import { VenueRequestComponent } from "./venue-request/venue-request.component";

// TODO: can we protect with canLoad?

export const routes: Routes = [
  {
    path: "",
    canActivateChild: [MaintenanceCheckGuard],
    children: [
      {
        path: "dashboard",
        loadChildren: () => import("src/app/features/client-portal/client-portal.module").then(m => m.ClientPortalModule),
        data: { preload: true, userTypes: [USER_TYPE_CLIENT] },
      },
      {
        path: "account",
        loadChildren: () => import("src/app/features/account/account.module").then(m => m.AccountModule),
        data: { preload: true, userTypes: [USER_TYPE_CLIENT, USER_TYPE_PARTNER, USER_TYPE_ADMIN] },
      },
      {
        path: "internals",
        loadChildren: () => import("src/app/features/admin-portal/admin-portal.module").then(m => m.AdminPortalModule),
        data: { preload: true, userTypes: [USER_TYPE_ADMIN] },
      },
      {
        path: "prod-support",
        loadChildren: () => import("src/app/features/prod-support/prod-support.module").then(m => m.ProdSupportModule),
        data: { preload: true, userRoles: [UserRoles.Support] },
      },
      {
        path: "api",
        loadChildren: () => import("src/app/features/external-developers/external-developers.module").then(m => m.ExternalDevelopersModule),
        data: { preload: true, userRoles: [UserRoles.ExternalDeveloper] },
      },
      {
        path: "oauth",
        loadChildren: () => import("src/app/features/oauth/oauth.module").then(m => m.OAuthModule),
      },
      {
        path: DEFAULT_PARTNER_ROUTE_PATH,
        loadChildren: () => import("src/app/features/partner-portal/partner-portal.module").then(m => m.PartnerPortalModule),
        data: { preload: true, userTypes: [USER_TYPE_PARTNER] },
      },
      {
        path: "demo/event",
        loadChildren: () => import("src/app/features/demo-event/demo-event.module").then(m => m.DemoEventModule),
        data: { preload: true, userTypes: [USER_TYPE_PARTNER] },
      },
      {
        path: DESIGN_GUEST_ROUTE_PATH,
        canDeactivate: [AuthGuestDeactivateGuard],
        loadChildren: () => import("src/app/features/guests/guests.module").then(m => m.GuestsModule),
      },
      {
        path: SHOWROOM_GUEST_ROUTE_PATH,
        canDeactivate: [AuthGuestDeactivateGuard],
        loadChildren: () => import("src/app/features/showrooms/showrooms.module").then(m => m.ShowroomsModule),
      },
      {
        path: EVENT_SUMMARY_GUEST_ROUTE_PATH,
        canDeactivate: [AuthGuestDeactivateGuard],
        loadChildren: () =>
          import("src/app/features/event-summary-guests/event-summary-guests.module").then(m => m.EventSummaryGuestsModule),
      },
      {
        path: "promo",
        loadChildren: () => import("src/app/features/promos/promos.module").then(m => m.PromosModule),
      },
      // {
      //   path: "connect",
      //   loadChildren: () => import("src/app/features/external-accounts/external-accounts.module").then(m => m.ExternalAccountsModule),
      //   // We can add more user types as we enable "connect" features in the future
      //   // We can also set partnerFeatures to limit loading for non-inspiration management partners
      //   data: { preload: true, userTypes: [USER_TYPE_PARTNER], partnerFeatures: [PartnerFeatures.InspirationManagement] },
      // },
      {
        path: "design/:eventId/:designId/:layoutId",
        canActivate: [AuthAnyGuard, InternalRedirectGuard],
        runGuardsAndResolvers: "always",
        component: PageNotFoundComponent,
      },
      {
        path: "event/:eventId",
        canActivate: [AuthAnyGuard, InternalRedirectGuard],
        runGuardsAndResolvers: "always",
        component: PageNotFoundComponent,
      },
      {
        path: "venue-search/:eventId",
        canActivate: [AuthAnyGuard, InternalRedirectGuard],
        runGuardsAndResolvers: "always",
        component: PageNotFoundComponent,
      },
      {
        path: "client-dashboard/:eventId",
        canActivate: [AuthAnyGuard, InternalRedirectGuard],
        runGuardsAndResolvers: "always",
        component: PageNotFoundComponent,
      },
      // keeping this for backwards compatibility -- START
      {
        path: "order/:orderNumber",
        canActivate: [AuthAnyGuard, InternalRedirectGuard],
        runGuardsAndResolvers: "always",
        component: PageNotFoundComponent,
      },
      {
        path: "order/:eventId/:vendorId",
        canActivate: [AuthAnyGuard, InternalRedirectGuard],
        runGuardsAndResolvers: "always",
        component: PageNotFoundComponent,
      },
      // keeping this for backwards compatibility -- END
      {
        path: `${OM_QUOTE_PATH}/:orderNumber`,
        canActivate: [AuthAnyGuard, InternalRedirectGuard],
        runGuardsAndResolvers: "always",
        component: PageNotFoundComponent,
      },
      {
        path: `${OM_QUOTE_PATH}/:eventId/:vendorId`,
        canActivate: [AuthAnyGuard, InternalRedirectGuard],
        runGuardsAndResolvers: "always",
        component: PageNotFoundComponent,
      },
      {
        path: "venue-request",
        canActivate: [AuthAnyGuard],
        runGuardsAndResolvers: "always",
        component: VenueRequestComponent,
      },
      {
        path: `${SHADOW_LOGIN_PATH}/:id`,
        canActivate: [AuthShadowGuard],
        runGuardsAndResolvers: "always",
        component: PageNotFoundComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProtectedRoutingModule {}
